import { render, staticRenderFns } from "./NgPhoneKeyboard.vue?vue&type=template&id=397cfd0c"
import script from "./NgPhoneKeyboard.vue?vue&type=script&lang=js"
export * from "./NgPhoneKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports